module.exports = "//public.getcloudapp.com/packs/media/images/bg-bottom-ba722ed77a154f1b620b1780dd939325.png";